"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RentalServices = void 0;
const RentalServices_yaml_component_1 = __importDefault(require("./RentalServices.yaml?component"));
exports.RentalServices = RentalServices_yaml_component_1.default;
